<!-- Navbar Start -->
<app-navbar></app-navbar>
<!-- Navbar End -->

<!-- Top Banner Section Start -->
<div class="mb-10 banner-container">
    <div class="grid grid-cols-12">
        <div class="col-span-12">
            <div class="w-full h-[450px] banner-wrapper">
                <img src="/assets/images/banners/reschedule-banner.png" alt=""
                    class="object-cover w-full h-full">
                    <div class="flex items-center h-full banner-container-inner">
                        <div class="container mx-auto">
                            <div class="p-[30px] text-center mt-[7em]">
                                <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                    <span class="font-bold mr-2">Reschedule Appointment</span>
                                </h1>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
<!-- Top Banner Section End -->

<!-- Calandar Component Start -->
<section class="w-full min-h-screen my-10">
    <app-slot-selection-reschedule [bookingData]="bookingData" [applicantId]="applicantId" [completeReschedule]="completeReschedule" [isChild]="isChild" [doctorId]="doctorId" [doctorBranchId]="doctorBranchId"
           [isLoading]="isLoading" [slots]="slots" [slotCheckCount]="slotCheckCount"
           [datesToHighlight]="datesToHighlight" *ngIf="datesToHighlight?.length > 0"></app-slot-selection-reschedule>
</section>
<!-- Calandar Component End -->

 <!-- Mat Spinner  -->
 <ngx-spinner bgColor="rgba(256, 256, 256, 0.7)" size="default" color="#558dca" type="ball-spin-fade"
 [fullScreen]="true">
 <p style="color: #558dca"> Please wait... </p>
</ngx-spinner>

<!-- Footer Start -->
<app-message></app-message>
<app-footer></app-footer>
<!-- Footer End -->